import { render, staticRenderFns } from "./RedeemReceipt.vue?vue&type=template&id=12156f42&scoped=true&"
import script from "./RedeemReceipt.vue?vue&type=script&lang=js&"
export * from "./RedeemReceipt.vue?vue&type=script&lang=js&"
import style0 from "./RedeemReceipt.vue?vue&type=style&index=0&id=12156f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12156f42",
  null
  
)

export default component.exports